<template>
    <div>
        <div class="banner">
            <div class="headerReplacementWarrantHoldersInfo"></div>
            <div class="banner-text">
                <b>{{ $t('warrantInfo.title') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('warrantInfo.home') }}</router-link></span>
                    <span class="separator"></span>
                    <span><b>{{ $t('warrantInfo.title') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <table class="table mt-3 mb-5">
                <thead>
                    <tr class="table-secondary text-center">
                        <th class="text-center align-middle" scope="col" style="font-size: clamp(12px, 1.5vw, 18px);">
                            <b>{{ $t('warrantInfo.title') }}</b>
                        </th>
                        <th scope="col" style="font-size: clamp(12px, 1.2vw, 14px);">
                            ORI - WA {{ $t('warrantInfo.round6') }}
                        </th>
                        <th scope="col" style="font-size: clamp(12px, 1.2vw, 14px);">
                            ORI - WB {{ $t('warrantInfo.round6') }}
                        </th>
                        <th scope="col" style="font-size: clamp(12px, 1.2vw, 14px);">
                            ORI - WC {{ $t('warrantInfo.round6') }}
                        </th>
                        <th scope="col" style="font-size: clamp(12px, 1.2vw, 14px);">
                            ORI - WD {{ $t('warrantInfo.round6') }}
                        </th>
                        <th scope="col" style="font-size: clamp(12px, 1.2vw, 14px);">
                            ORI - W1 {{ $t('warrantInfo.lastRound') }}
                        </th>
                        <th class="text-center align-middle" scope="col" style="font-size: clamp(12px, 1.2vw, 14px);">
                            ORI - W2
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in 6" :key="index">
                        <th scope="row">{{ $t(`warrantInfo.row${index + 1}`) }}</th>
                        <td v-for="(link, col) in downloadLinks[`row${index + 1}`][currentLang]" :key="col"
                            class="text-center align-middle">
                            <a v-if="link" :href="link" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
  
<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        BasicInfoTabMenu,
    },
    data() {
        return {
            downloadLinks: {
                row1: {
                    th: [
                        "https://origin-console-service.onrender.com/api/upload/file/1738901786918-20180823-ori-warrant-wa-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738901936827-20200309-ori-warrant-wb-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902016814-20210916-ori-warrant-wc-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902086815-20220217-ori-warrant-wd-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902171333-20200903-ori-warrant-w1-last-notification-th.pdf",
                        ""
                    ],
                    en: ["https://origin-console-service.onrender.com/api/upload/file/1738901786918-20180823-ori-warrant-wa-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738901936827-20200309-ori-warrant-wb-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902016814-20210916-ori-warrant-wc-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902086815-20220217-ori-warrant-wd-06-notification-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902171333-20200903-ori-warrant-w1-last-notification-th.pdf",
                        ""]
                },
                row2: {
                    th: [
                        "https://origin-console-service.onrender.com/api/upload/file/1738902300918-20180823-ori-warrant-wa-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902389561-20200309-ori-warrant-wb-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902460386-20210916-ori-warrant-wc-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902523526-20220217-ori-warrant-wd-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902687764-20200903-ori-warrant-w1-last-subscription-form-th.pdf",
                        ""
                    ],
                    en: ["https://origin-console-service.onrender.com/api/upload/file/1738902300918-20180823-ori-warrant-wa-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902389561-20200309-ori-warrant-wb-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902460386-20210916-ori-warrant-wc-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902523526-20220217-ori-warrant-wd-06-subscription-form-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738902687764-20200903-ori-warrant-w1-last-subscription-form-th.pdf",
                        ""]
                },
                row3: {
                    th: ["", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1738902777468-20200903-ori-warrant-w1-last-bill-payment.pdf", ""],
                    en: ["", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1738902777468-20200903-ori-warrant-w1-last-bill-payment.pdf", ""]
                },
                row4: {
                    th: [
                        "https://origin-console-service.onrender.com/api/upload/file/1738902970314-20160311-ori-warrant-wa-summary-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738903041871-20170905-ori-warrant-wb-scheme-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738903141139-20180823-ori-warrant-wc-scheme-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738903192369-20190903-ori-warrant-wd-01-scheme-th.pdf",
                        "",
                        ""
                    ],
                    en: ["https://origin-console-service.onrender.com/api/upload/file/1738902970314-20160311-ori-warrant-wa-summary-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738903041871-20170905-ori-warrant-wb-scheme-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738903141139-20180823-ori-warrant-wc-scheme-th.pdf",
                        "https://origin-console-service.onrender.com/api/upload/file/1738903192369-20190903-ori-warrant-wd-01-scheme-th.pdf",
                        "",
                        ""]
                },
                row5: {
                    th: ["", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1738903280820-20171115-ori-warrant-w1-01-th.pdf", "https://origin-console-service.onrender.com/api/upload/file/1747971192099-terms-of-rights-TH.pdf"],
                    en: ["", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1738903280820-20171115-ori-warrant-w1-01-th.pdf", "https://origin-console-service.onrender.com/api/upload/file/1747971192099-terms-of-rights-TH.pdf"],
                },
                row6: {
                    th: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1747971191410-Summary-of-information-TH.pdf"],
                    en: ["", "", "", "", "", "https://origin-console-service.onrender.com/api/upload/file/1747971191410-Summary-of-information-TH.pdf"]
                }
            }
        };
    },
    computed: {
        currentLang() {
            return this.$i18n.locale || 'th';
        }
    },
    methods: {}
};
</script>
  
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  

<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  